var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 40,
    viewBox: "0 0 67 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 10178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 117",
    filter: "url(#filter0_bdi_2745_10771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7548 12.8069C20.9766 14.899 20.9766 18.2662 20.9766 25.0006C20.9766 31.7349 20.9766 35.1021 22.7548 37.1942C24.5324 39.2855 27.393 39.2863 33.1128 39.2863C38.8326 39.2863 41.6931 39.2855 43.4707 37.1942C45.249 35.1021 45.249 31.7349 45.249 25.0006C45.249 18.2662 45.249 14.899 43.4707 12.8069C41.6931 10.7157 38.8326 10.7148 33.1128 10.7148C27.393 10.7148 24.5324 10.7157 22.7548 12.8069Z",
    fill: "white",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.1191 19.2871H38.1191M28.1191 26.43H32.4049",
    stroke: "#EAE8ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.3787 38.9469C42.5994 39.0134 42.8151 39.1266 43.2464 39.353C44.2524 39.8809 44.7554 40.1448 45.0912 40.1436C45.7899 40.1411 46.3817 39.6024 46.4829 38.8767C46.5316 38.528 46.3537 37.9681 45.9981 36.8482L45.0656 33.9121C44.1745 34.5608 43.0773 34.9435 41.8907 34.9435H41.4907C40.3042 34.9435 39.207 34.5608 38.3159 33.9121L37.3834 36.8482L37.3834 36.8482C37.0277 37.9681 36.8499 38.528 36.8985 38.8767C36.9997 39.6024 37.5916 40.1411 38.2903 40.1436C38.6261 40.1448 39.1291 39.8809 40.135 39.353C40.5664 39.1266 40.7821 39.0134 41.0028 38.9469C41.4523 38.8113 41.9291 38.8113 42.3787 38.9469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.89 24.1445H41.49C38.5076 24.1445 36.0898 26.5622 36.0898 29.5446C36.0898 31.3405 36.9664 32.9316 38.3151 33.9134C39.2062 34.5621 40.3034 34.9448 41.49 34.9448H41.89C43.0765 34.9448 44.1737 34.5621 45.0648 33.9134C46.4135 32.9316 47.2901 31.3405 47.2901 29.5446C47.2901 26.5622 44.8724 24.1445 41.89 24.1445Z",
    fill: "#7750E9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_2745_10771",
    x: 0.976562,
    y: 0.714844,
    width: 64.2734,
    height: 68.5723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2745_10771"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2745_10771",
    result: "effect2_dropShadow_2745_10771"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2745_10771",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2745_10771"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificationIcon);
export default __webpack_public_path__ + "static/media/certification_icon.b6af362cb5ba2406647899369f26c74b.svg";
export { ForwardRef as ReactComponent };